import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"selection-indicator\"></span>\n\n<span class=\"period-title\">\n  {{period-title this.rowValue showDateRange=true fullDay=this.selectKit.options.fullDay}}\n</span>", {
  moduleName: "select-kit/components/period-chooser/period-chooser-row.hbs"
});